

import React from "react";

function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer>
      <p>Copyright ⓒ {year} Made with ❤ by Roopshree</p>
    </footer>
  );
}

export default Footer;
